<template>
  <section class="px-6">
    <v-container v-if="_isXAdmin(userProfile)">
      <v-row justify="end">
        <v-toolbar flat color="transparent">
          <v-row justify="space-between">
            <v-col cols="12" md="4" lg="4" class="d-flex flex-row">
              <v-select
                v-if="xprofessions"
                v-model="selectedProfession"
                :items="xprofessions"
                label="Мэргэжил"
                return-object
                item-text="name2"
                item-value="id"
              >
              </v-select>

              <v-btn
                v-if="selectedProfession != null"
                color="blue"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="selectedProfession = null"
                >Clear</v-btn
              >
              <!-- <v-btn
                color="red"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="_increaseClasses(null)"
                >Анги дэвшүүл</v-btn
              > -->
            </v-col>
            <v-row align="center" justify="end">
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Xайx"
                ></v-text-field>
              </v-col>

              <!-- <v-btn
                color="gray"
                elevation="0"
                class="mb-2 pa-0"
                @click="_deleteAll(school)"
                title="Бөнөөр нэмэx"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn> -->
              <v-btn
                small
                color="gray"
                elevation="0"
                class="mb-2 pa-0"
                @click="_newBulkDialog(null)"
                title="Бөнөөр нэмэx"
              >
                <v-icon>mdi-animation</v-icon>
              </v-btn>
              <v-btn
                small
                color="secondary"
                elevation="0"
                class="mb-2"
                @click="_newDialog(null)"
                title="Шинээр нэмэx"
              >
                <v-icon>mdi-playlist-plus</v-icon>
              </v-btn>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      v-if="items && items.length > 0 && loading == false"
    >
      <!-- <v-btn @click="_changeAll">change All</v-btn> -->
      <v-row justify="end" class="mx-4">
        <v-col>
          <h3>{{ numberOfselectedItems }}</h3>
        </v-col>
        <v-col cols="auto">
          <v-checkbox label="Төгссөн" v-model="isStudied"></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            label="Тодорxойгүй"
            v-model="isStudyingUndefined"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            label="Суралцаж байгаа оюутнууд"
            v-model="isStudying"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="selectedItems"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.studentCode }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.register }}</td>
            <td style="background: #fff9c4">{{ props.item.currentGPA }}</td>
            <!-- <td class="font-weight-bold">
              <span v-if="props.item.classGroupProgram">{{
                props.item.classGroupProgram.name2
              }}</span>
              <span v-else>-</span>
            </td> -->

            <td class="font-weight-bold">
              <span v-if="props.item['xClassGroupProgram-2022-2023-1']"
                >{{ props.item["xClassGroupProgram-2022-2023-1"].name2 }}
              </span>
              <span v-else>-</span>
            </td>
            <!-- <td class="font-weight-bold red--text">
              <span v-if="props.item['xClassGroupRef-' + _getPostFix()]">{{
                props.item["xClassGroupRef-" + _getPostFix()].id
              }}</span>
              <span v-else>-</span>
            </td> -->
            <td v-if="props.item.state">
              <small v-if="props.item.state.code == 1" style="color: green">{{
                props.item.state.name
              }}</small>
              <small v-else style="color: red">{{
                props.item.state.name
              }}</small>
            </td>
            <td v-else>-</td>
            <td>
              <v-btn
              v-if="
                  userProfile.role == 'admin' ||
                  userProfile.role == 'diplomaorganizator'
                "
                elevation="0"
                color="primary"
                x-small
                @click="_editItemForScore(props.item, props.item.index)"
                >Голч+</v-btn
              >
            </td>
            <td>
              <v-btn
              v-if="
                  userProfile.role == 'admin' ||
                  userProfile.role == 'diplomaorganizator'
                "
                elevation="0"
                color="secondary"
                x-small
                @click="_addScores(props.item, props.item.index)"
                >Дүнгүүд+</v-btn
              >
            </td>

            <!-- <td>
              <v-btn
                v-if="userProfile.role == 'admin'"
                elevation="0"
                class="red lighten-4 red--text"
                x-small
                @click="_addSingleScoreDialog(props.item, props.item.index)"
                >Дүн+</v-btn
              >
            </td> -->

            <!-- <td>
              <v-btn
                @click="_changeState(props.item)"
                x-small
                color="primary"
                elevation="0"
                class="text-caption text-lowercase"
                >Төлөв өөрчлөx</v-btn
              >
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </material-card>
    <v-card v-if="loading" height="200">
      <v-progress-linear
        height="25"
        indeterminate
        color="red"
      ></v-progress-linear>
    </v-card>
    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Шинэ/нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.firstName" label="Нэр" />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.lastName" label="Овог" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model.trim="editedItem.studentCode"
                  label="Оюутны код"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.phone" label="Утас" />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.register"
                  label="Регистр"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model.trim="editedItem.email" label="Имэйл" />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
                lg="8"
                v-if="xClassGroups && xClassGroups.length > 0"
              >
                <v-select
                  v-model="selectedClassGroup"
                  :items="xClassGroups"
                  label="Мэргэжил"
                  return-object
                  item-text="name2"
                  item-value="id"
                >
                </v-select>
              </v-col>

              <v-col cols="4" sm="4" md="4" v-if="selectedClassGroup">
                <v-select
                  v-model="selectedClassGroupProgram"
                  :items="selectedClassGroup.programs"
                  return-object
                  item-text="name2"
                  item-value="id"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.state"
                  :items="xBeingStates"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Төлөв"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  type="Number"
                  v-model.number="editedItem.enteredYear"
                  label="Элссэн жил"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  type="Number"
                  v-model.number="editedItem.finishedYear"
                  label="Дууссан жил"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text font-weight-bold"
              >{{ this.messageNotification }}
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newBulkDialog" max-width="800px" height="2200px">
      <v-card class="py-4">
        <v-card-title class="headline"> Бөөнөөр нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="10" sm="10" md="10">
                <v-select
                  v-model="bulkXprofession"
                  :items="vselect_professions"
                  label="Мэргэжил"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-select
                  v-model="bulkYear"
                  :items="[1, 2, 3, 4, 5, 6]"
                  label="Ангийн дугаар"
                >
                </v-select>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <p class="red--text">
                  {{ messageNotification }}
                </p>
                <p class="text-wrap text--primary">
                  <span class="font-weight-bold"
                    >Оюутны код, овог, нэр, регистер, утас</span
                  >
                  дараалалтай мэдээллийг оруулаx!!!
                </p>
                <v-textarea
                  v-if="bulkText == null"
                  v-model="bulkText"
                  outlined
                  label="Xүснэгтэн мэдээлэл оруулаx"
                  @input="_bulkTextGiven(bulkText)"
                />

                <v-container v-else style="overflow-y: scroll">
                  <material-card
                    icon="mdi-clipboard-text"
                    icon-small
                    color="accent"
                  >
                    <v-simple-table v-if="tmpItems && tmpItems.length > 0">
                      <thead>
                        <tr>
                          <th class="primary--text">ID</th>
                          <th class="primary--text">Код</th>
                          <th class="primary--text">Овог</th>
                          <th class="primary--text">Нэр</th>
                          <th class="primary--text">Регистр</th>
                          <th class="primary--text">Имэйл</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in tmpItems"
                          v-bind:key="index"
                          @click="_detail(item, index)"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.studentCode }}</td>
                          <td>{{ item.lastName }}</td>
                          <td>{{ item.firstName }}</td>
                          <td>{{ item.register }}</td>
                          <td>{{ item.phone }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </material-card>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red darken-1"
            class="white--text"
            @click="_clearBulkText"
          >
            Арилгаx
          </v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.firstName }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.firstName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.lastName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.phone }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.email }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-card-title> Устгаxыг xүсэж байна уу? </v-card-title>
        <v-card-title
          >{{ editedItem.firstName }}, {{ editedItem.studentCode }}
        </v-card-title>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="secondary" @click="_deleteOK()">Устгаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="inputScoreDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Дүн оруулаx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  autofocus
                  type="Number"
                  v-model.number="editedItem.currentGPA"
                  label="Score"
                />
              </v-col>

              <!-- <v-col cols="12">
                <v-select
                  v-model="editedItem.semester"
                  :items="xsemesters"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Semester"
                >
                </v-select>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveScore"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newScoreDialog" max-width="500px">
      <v-card class="py-4" v-if="editedItem">
        <v-card-title class="headline"> Дүн оруулаx, засаx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.lessonCode"
                  label="lessonCode"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model.number="editedItem.score30"
                  type="number"
                  label="score30"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model.number="editedItem.score70"
                  type="number"
                  label="score70"
                />
              </v-col>

              <!--  -->
              <!-- 
              <v-col cols="4">
                <v-select
                  :items="xyears"
                  v-model="editedItem.xyear"
                  label="xyear"
                  return-object
                  item-text="name"
                  item-value="id"
                />
              </v-col> -->

              <v-col cols="6">
                <v-select
                  :items="xyears"
                  v-model="editedItem.xyear"
                  label="xyear"
                  return-object
                  item-text="name"
                  item-value="id"
                />
              </v-col>
              <v-col
                cols="6"
                v-if="editedItem.xyear && editedItem.xyear.semesters"
              >
                <v-select
                  :items="editedItem.xyear.semesters"
                  v-model="editedItem.semester"
                  label="semester"
                  return-object
                  item-text="shortName"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeSingleScoreDialog">
            Цуцлаx
          </v-btn>
          <v-btn color="blue darken-1" @click="_saveSingleScore">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "StudentTable2",
  data: () => ({
    newScoreDialog: false,
    xyears: null,
    xsemesters: null,
    inputScoreDialog: false,
    isStudyingUndefined: true,
    isStudying: true,
    isStudied: false,
    selectedClassGroup: null,
    selectedClassGroupProgram: null,
    xBeingStates: null,
    loading: false,
    search: "",
    selectedProfession: null,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      firstName: "",
    },
    editedIndex: -1,
    defaultItem: {
      firstName: "",
    },
    items: [],

    messageNotification: null,

    bulkText: null,
    bulkXprofession: null,
    bulkYear: null,
    xprofessions: null,
    vselect_professions: [],
    xClassGroups: null,
    tmpItems: [],
  }),
  mixins: [myfunction],
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    // selectedItems: function () {
    //   if (this.selectedProfession != null) {
    //     if (this.selectedProfession.all) {
    //       return this.items;
    //     } else {
    //       return this.items.filter(
    //         (item) =>
    //           item.xprofession &&
    //           item.xprofession.shortName === this.selectedProfession.shortName
    //       );
    //     }
    //   } else {
    //     return this.items;
    //   }
    // },
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "studentCode",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
        },
        {
          text: "Регистр",
          align: "start",
          sortable: true,
          value: "register",
        },
        {
          text: "GPA",
          align: "start",
          sortable: true,
          value: "currentGPA",
        },
        {
          text: "Мэргэжил/Анги",
          align: "start",
          sortable: true,
          value: "classGroupName",
        },
        {
          text: "Төлөв",
          align: "start",
          sortable: true,
          value: "state.name2",
        },
      ];
    },
    numberOfselectedItems: function () {
      if (this.selectedItems) return this.selectedItems.length;
      else return null;
    },
    selectedItems: function () {
      var list = [];
      if (this.items != null) {
        var counter = 0;
        if (this.selectedProfession != null) {
          if (this.selectedProfession.all) {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              //this._setXClass(item);
              if (
                this.isStudying &&
                item.state &&
                item.state.id != "HwCdcfzoY7vc6EUOtREf"
              )
                list.push(item);
            }
          } else {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              if (
                item["xClassGroupRef-" + this._getPostFix()] &&
                item["xClassGroupRef-" + this._getPostFix()].id ===
                  this.selectedProfession.id
              ) {
                //this._setXClass(item);
                if (
                  this.isStudying &&
                  item.state &&
                  item.state.id != "HwCdcfzoY7vc6EUOtREf"
                )
                  list.push(item);
              }
            }
          }
        } else {
          for (var item of this.items) {
            //this._setXClass(item);
            if (this.isStudying) {
              if (item.state && item.state.id != "HwCdcfzoY7vc6EUOtREf") {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudyingUndefined && this.isStudying == false) {
              if (item.state == undefined) {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudied) {
              if (item.state && item.state.name == "Төгссөн") {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (
              !this.isStudying &&
              !this.isStudyingUndefined &&
              !this.isStudied
            ) {
              counter++;
              item.index = counter;
              list.push(item);
            }
          }
        }
      }
      return list;
    },
  },
  created() {
    fb.db
      .collection(fb.yyschool + "/xschoolyears")
      .get()
      .then((docs) => {
        this.xyears = [];
        docs.forEach((doc) => {
          let xyear = doc.data();
          xyear.ref = doc.ref;
          xyear.id = doc.id;
          xyear.semesters = null;
          doc.ref
            .collection("semesters")
            .get()
            .then((docs) => {
              xyear.semesters = [];
              docs.forEach((doc) => {
                let semester = doc.data();
                semester.ref = doc.ref;
                semester.id = doc.id;
                console.log(semester.ref.path);
                xyear.semesters.push(semester);
              });
            });
          this.xyears.push(xyear);
        });
      });

    this._setupp();
    this._read();
  },

  methods: {
    _saveSingleScore() {
      var score = {
        score30: this.editedItem.score30,
        score70: this.editedItem.score70,
        semesterName: this.editedItem.semester.shortName,
        schoolYear:
          this.editedItem.semester.startYear +
          "-" +
          this.editedItem.semester.endYear,
        xyear: this.editedItem.xyear,
        lessonCode: this.editedItem.lessonCode.toLowerCase(),
        scoreTotal: this.editedItem.score30 + this.editedItem.score70,
      };
      this.editedItem.ref
        .collection("scores")
        .doc(this.editedItem.lessonCode.toLowerCase())
        .set(score, { merge: true })
        .then(() => {
          this._closeSingleScoreDialog();
        });
    },

    _addSingleScoreDialog(user, userIndex) {
      this.editedItem = user
      this.editedItem["lessonCode"] = null
      this.editedItemIndex = -1;
      this.newScoreDialog = true;
    },

    _closeSingleScoreDialog() {
      this.newScoreDialog = false;
      this.editedItem = {};
      this.editedItemIndex = -1;
    },

    _getPostFix() {
      return "2022-2023-1";
    },
    _changeAll() {
      this.items.forEach((student) => {
        this._changeState(student);
      });
    },
    _changeState(item) {
      console.log(item["xClassGroupRef-" + this._getPostFix()].path);
      // var xstate = {
      //   code: 1,
      //   description: null,
      //   name: "Суралцаж байгаа",
      //   shortName: "studying",
      //   id: "mSTS4l9Rsd04rlHl1h2g",
      // };
      // // this.items.forEach((student) => {
      // //   student.ref.update({
      // //     state: xstate,
      // //     "classGroup-2022-2023-1": student.classGroup,
      // //     "classGroupRef-2022-2023-1": student.classGroupRef,
      // //     "classGroupProgram-2022-2023-1": student.classGroupProgram,
      // //     "classGroupProgramRef-2022-2023-1": student.classGroupProgramRef,
      // //   });
      // // });
      // if (
      //   item["xClassGroupRef-" + this._getPostFix()] && item["xClassGroupRef-" + this._getPostFix()].ref
      // ) {
      //   var dataa = {
      //     state: xstate,
      //     // classGroupRef: fb.firestore.FieldValue.delete(),
      //     // classGroupProgramRef: fb.firestore.FieldValue.delete(),
      //     // classGroup: fb.firestore.FieldValue.delete(),
      //     // classGroupProgram: fb.firestore.FieldValue.delete(),
      //   };

      //   dataa["xClassGroupRef-" + this._getPostFix()] = item["xClassGroupRef-" + this._getPostFix()].ref;

      //   // dataa["xClassGroupProgramRef-" + this._getPostFix()] =
      //   //   item.classGroupProgramRef;

      //   // dataa["xClassGroupProgram-" + this._getPostFix()] =
      //   //   item.classGroupProgram;

      //   item.ref.update(dataa).then(() => {
      //     console.log("updated!!!");
      //   });
      // }
    },
    _setXClass(student) {
      if (student.xprofession) {
        if (student.classNumber) {
          student.xClass =
            student.xprofession.shortName + "-" + student.classNumber;
        } else student.xClass = student.xprofession.shortName + "-x";
      }
    },
    _increaseClasses() {
      var counter = 0;
      for (var student of this.items) {
        counter++;
        if (student["classIncreased-2021"] == true) {
          console.log(counter, student.ref.id);
          // student.ref
          //   .update({
          //     classNumber: student.classNumber + 1,
          //     "classIncreased-2021": true,
          //   })
          //   .then(() => {
          //     console.log(counter);
          //   });
        } else {
          console.log(counter, student.ref.path);
          // student.ref
          //   .update({
          //     classNumber: student.classNumber + 1,
          //     "classIncreased-2021": true,
          //   })
          //   .then(() => {
          //     console.log(counter);
          //   });
        }
      }
    },
    _clearBulkText() {
      this.bulkText = null;
      this.tmpItems = [];
    },
    _bulkTextGiven(bulkText) {
      if (this.bulkText != null && this.bulkText != "") {
        if (this.bulkText != null && this.bulkText != "") {
          var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);
          if (arrayOfLines != null && arrayOfLines.length > 0) {
            arrayOfLines.forEach((value) => {
              var lineArray = value.split(/\s+/);
              var newItem = {
                studentCode: lineArray[0].trim(),
                lastName: lineArray[1].trim(),
                firstName: lineArray[2].trim(),
                register: lineArray[3].trim(),
                phone: lineArray[4].trim(),
                classNumber: parseInt(this.bulkYear),
                createdAt: new Date(),
              };

              if (this.bulkXprofession != null)
                newItem.xprofession = {
                  name: this.bulkXprofession.name,
                  shortName: this.bulkXprofession.shortName,
                  ref: this.bulkXprofession.ref,
                };

              this.tmpItems.push(newItem);
            });
          }
        }
      } else {
        this.messageNotification = "Мэргэжил, ангийн дугаарыг сонгоx!!!";
      }
    },
    _deleteAll(school) {
      if (school) {
        for (var emp of school.employees) {
          emp.ref
            .delete()
            .then(() => {
              console.log("Document successfully deleted!");
            })
            .catch((error) => {
              console.error("Error removing document: ", error);
            });
        }
      } else {
        confirm("Nulll");
      }
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      } else {
      }
    },
    _newBulkDialog(item, index) {
      this.editedItem = {};
      this.editedIndex = -1;
      this.newBulkDialog = true;
    },
    _detail(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "StudentDetail",
        params: { studentPath: item.ref.path, collectionpath: "payments" },
      });
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
      // this.editedIndex = this.participants.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // fb.db.collection("asuulga/" + this.asuulgaId + "/users").doc(item.id);
    },
    _editItem(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.selectedClassGroup = this.editedItem["xClassGroupRef-2022-2023-1"];
      if (this.selectedClassGroup) {
        for (const cg of this.xClassGroups) {
          if (cg.id == this.selectedClassGroup.id) {
            this.selectedClassGroup.programs = cg.programs ? cg.programs : null;
            break;
          }
        }

        this.selectedClassGroupProgram =
          this.editedItem["xClassGroupProgram-2022-2023-1"];

        console.log(this.selectedClassGroupProgram);
      }

      this.newDialog = true;
    },
    _editItemForScore(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.inputScoreDialog = true;
    },

    _addScores(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "AdminStudentScores",
        params: { studentPath: item.ref.path },
      });
    },
    _addCV(user) {
      this.$router.push({
        name: "CvUser",
        params: {
          schoolId: this.school.id,
          collectionName: this.item.fbpath,
          userId: user.id,
        },
      });
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.inputScoreDialog = false;
      this.tmpItems = [];

      this.bulkText = null;
      this.bulkXprofession = null;
      this.bulkYear = null;
      this.messageNotification = null;

      this.selectedClassGroup = null;
      this.selectedClassGroupProgram = null;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveScore() {
      this.editedItem.ref
        .update({
          currentGPA: this.editedItem.currentGPA,
          currentGPADate: new Date(),
        })
        .then(() => {
          this.newDialog = false;
          this.newBulkDialog = false;
          this.inputScoreDialog = false;
        });
    },
    saveItem() {
      var isFirstName = false;
      var isLastName = false;
      var isStudentCode = false;
      var isPhone = false;
      var isEmail = false;

      var isBulkXprofession = false;
      var isBulkYear = false;

      var messages = [];
      if (
        this.editedItem.firstName &&
        this.editedItem.firstName.trim() !== ""
      ) {
        isFirstName = true;
      } else messages.push("Нэр");

      if (this.editedItem.lastName && this.editedItem.lastName.trim() !== "") {
        isLastName = true;
      } else messages.push("Овог");

      if (
        this.editedItem.studentCode &&
        this.editedItem.studentCode.trim() !== ""
      ) {
        isStudentCode = true;
      } else messages.push("Оюутны код");

      if (this.editedItem.phone && this.editedItem.phone.trim() !== "") {
        isPhone = true;
      } else messages.push("Утас");

      if (this.editedItem.email && this.editedItem.email.trim() !== "") {
        isEmail = true;
      } else messages.push("Имэйл");

      if (this.bulkXprofession != null) {
        isBulkXprofession = true;
      } else messages.push("Мэргэжил");

      if (this.bulkYear != null) {
        isBulkYear = true;
      } else messages.push("Анги");

      this.editedItem.role = "student";

      if (
        isFirstName
        //&&isEmail
        // isLastName &&
        // isPhone &&
        // isBulkXprofession &&
        // isBulkYear
      ) {
        console.log(this.editedItem);

        this.editedItem.createdAt = new Date();

        if (this.selectedClassGroup) {
          this.editedItem["xClassGroupRef-" + this._getPostFix()] =
            this.selectedClassGroup;
        }
        if (this.selectedClassGroupProgram) {
          this.editedItem["xClassGroupProgram-" + this._getPostFix()] =
            this.selectedClassGroupProgram;

          this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
            this.selectedClassGroupProgram.ref;
          // if (
          //   this.selectedClassGroupProgram &&
          //   this.selectedClassGroupProgram.ref
          // ) {
          //   this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
          //     this.selectedClassGroupProgram.ref;
          // } else {
          //   this.editedItem["xClassGroupProgramRef-" + this._getPostFix()] =
          //     this.selectedClassGroupProgram;
          // }
          console.log(this.selectedClassGroupProgram);
        }

        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          if (this.bulkXprofession != null)
            this.editedItem.xprofession = {
              name: this.bulkXprofession.name,
              shortName: this.bulkXprofession.shortName,
              ref: this.bulkXprofession.ref,
            };

          // if (this.bulkYear != null)
          //   (this.editedItem.classNumber = parseInt(this.bulkYear)),
          console.log(this.editedItem);

          if (this.editedItem.email)
            this.editedItem.email = this.editedItem.email.toLowerCase();

          if (
            this.editedItem.register != undefined &&
            this.editedItem.register != null &&
            this.editedItem.register != ""
          )
            this.editedItem.register = this.editedItem.register.toLowerCase();

          this.school.ref
            .collection("students")
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          if (
            this.editedItem.register != undefined &&
            this.editedItem.register != null &&
            this.editedItem.register != ""
          )
            this.editedItem.register = this.editedItem.register.toLowerCase();

          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification = null;
        for (const m of messages) {
          if (this.messageNotification == null) this.messageNotification = m;
          else this.messageNotification = this.messageNotification + ", " + m;
        }
        this.messageNotification =
          this.messageNotification + " - " + messages.length + " сонгоx!!!";
      }
    },
    saveBulk() {
      console.log(this.bulkYear);
      console.log(this.bulkXprofession);
      console.log(this.bulkText);
      if (
        this.bulkXprofession != null &&
        this.bulkYear != null &&
        this.bulkText != null &&
        this.bulkText != ""
      ) {
        var batch = fb.db.batch();
        if (this.bulkText != null && this.bulkText != "") {
          var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);
          if (arrayOfLines != null && arrayOfLines.length > 0) {
            arrayOfLines.forEach((value) => {
              var lineArray = value.split(/\s+/);

              // console.log(lineArray.length);
              // console.log(lineArray[0], lineArray[0].length);
              // console.log(lineArray[1], lineArray[0].length);
              // console.log(lineArray[2], lineArray[0].length);
              // console.log(lineArray[3], lineArray[0].length);
              // console.log(lineArray[4], lineArray[0].length);

              var newItem = {
                studentCode: lineArray[0].trim(),
                lastName: lineArray[1].trim(),
                firstName: lineArray[2].trim(),
                register: lineArray[3].trim(),
                phone: lineArray[4].trim(),
                classNumber: parseInt(this.bulkYear),
                createdAt: new Date(),
              };

              if (this.bulkXprofession != null)
                newItem.xprofession = {
                  name: this.bulkXprofession.name,
                  shortName: this.bulkXprofession.shortName,
                  ref: this.bulkXprofession.ref,
                };

              var xx = fb.db.collection(this._getPath()).doc();
              batch.set(xx, newItem);
            });
          }
        }
        batch.commit().then(() => {
          this.bulkText = null;
          this._closeEdit();
        });
      } else {
        this.messageNotification = "Мэргэжил, ангийн дугаарыг сонгоx!!!";
      }
    },
    _setupp() {
      console.log(this.school);
      this.school.ref
        .collection("/xprofessions")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xprofessions = [{ name2: "Бүгд", all: true }];
          this.vselect_professions = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.name2 = "(" + item.shortName + ") " + item.name;
            this.xprofessions.push(item);
            this.vselect_professions.push(item);
          });
        });
      this.school.ref
        .collection("xschoolyears")
        .orderBy("createdAt", "asc")
        .onSnapshot((querySnapshot) => {
          this.xsemesters = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.ref
              .collection("semesters")
              .get()
              .then((xdocs) => {
                this.xsemesters = [];
                xdocs.forEach((xdoc) => {
                  let sem = xdoc.data();
                  sem.id = xdoc.id;
                  sem.ref = xdoc.ref;
                  sem.name2 =
                    sem.startYear + "-" + sem.endYear + "-" + sem.code;
                  sem.name =
                    sem.startYear + "-" + sem.endYear + ", " + sem.shortName;
                  this.xsemesters.push(sem);
                });
              });
          });
        });
      this.school.ref
        .collection("/xBeingStates")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xBeingStates = [];
          this.vselect_professions = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.xBeingStates.push(item);
          });
        });
      this.school.ref
        .collection("/classGroups/2022-2023/classGroups")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xClassGroups = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.programs = null;
            item.name2 =
              item.name +
              " (" +
              item.shortName +
              ")" +
              " /" +
              item.degreeName +
              "/";
            item.ref.collection("programs").onSnapshot((docs) => {
              item.programs = [];
              docs.forEach((doc) => {
                var program = doc.data();
                program.ref = doc.ref;
                program.id = doc.id;
                program.name2 = program.shortName + "-" + program.classNumber;
                item.programs.push(program);
              });
            });

            this.xClassGroups.push(item);
          });
        });
    },
    _read() {
      this.loading = true;
      this.school.ref
        .collection("students")
        .orderBy("firstName", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            // console.log(
            //   item,
            //   item["xClassGroupProgram-" + this._getPostFix()].name2,
            //   "xClassGroupProgram-" + this._getPostFix()
            // );
            if (
              item["xClassGroupProgram-" + this._getPostFix()] &&
              item["xClassGroupProgram-" + this._getPostFix()].name2
            ) {
              item.classGroupName =
                item["xClassGroupProgram-" + this._getPostFix()].name2;
            } else item.classGroupName = null;
            // if (item.professionRef == undefined) {
            //   if (item.xprofession) {
            //     item.professionRef = item.xprofession.ref;
            //     item.xprofession.id = item.xprofession.ref.id;
            //     //item.ref.update(item);
            //   }
            // }
            this.items.push(item);
          });
          this.loading = false;
        });
    },
  },
};
</script>
